import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CircularProgress,
} from '@mui/material';
import {
  OrganizationCreateRequest,
} from '../../services/organizationApi';

interface CreateOrganizationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: OrganizationCreateRequest;
  setForm: (form: OrganizationCreateRequest) => void;
  loading: boolean;
}

const CreateOrganizationDialog: React.FC<CreateOrganizationDialogProps> = ({
  open,
  onClose,
  onSubmit,
  form,
  setForm,
  loading,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Create New Organization</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            <TextField
              fullWidth
              label="Organization Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              margin="normal"
              required
              disabled={loading}
            />
            <TextField
              fullWidth
              label="Description"
              value={form.description || ''}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              margin="normal"
              multiline
              rows={3}
              disabled={loading}
            />
            <TextField
              fullWidth
              label="Domain"
              value={form.domain || ''}
              onChange={(e) => setForm({ ...form, domain: e.target.value })}
              margin="normal"
              placeholder="example.com"
              disabled={loading}
            />
            <TextField
              fullWidth
              label="Logo URL"
              value={form.logo_url || ''}
              onChange={(e) => setForm({ ...form, logo_url: e.target.value })}
              margin="normal"
              placeholder="https://example.com/logo.png"
              disabled={loading}
            />
            <TextField
              fullWidth
              label="Website"
              value={form.website || ''}
              onChange={(e) => setForm({ ...form, website: e.target.value })}
              margin="normal"
              placeholder="https://example.com"
              disabled={loading}
            />
            <TextField
              fullWidth
              label="Industry"
              value={form.industry || ''}
              onChange={(e) => setForm({ ...form, industry: e.target.value })}
              margin="normal"
              placeholder="Technology, Healthcare, etc."
              disabled={loading}
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Organization Size</InputLabel>
              <Select
                value={form.size || ''}
                label="Organization Size"
                onChange={(e) => setForm({ ...form, size: e.target.value })}
                disabled={loading}
              >
                <MenuItem value="1-10">1-10 employees</MenuItem>
                <MenuItem value="11-50">11-50 employees</MenuItem>
                <MenuItem value="51-200">51-200 employees</MenuItem>
                <MenuItem value="201-1000">201-1000 employees</MenuItem>
                <MenuItem value="1000+">1000+ employees</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loading || !form.name}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Creating...' : 'Create Organization'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateOrganizationDialog;
